<div class="app-dot-container">
  <div [class]="'clsGrid_dot ' + defineAppDotClass()"></div>
  <p>{{ label }}</p>
</div>
